import React, { useEffect, useCallback } from 'react';
import HoverEffect from './HoverEffect';
import Resume from './Resume';
import './Portfolio.css';

const Portfolio = () => {
  const rand = useCallback((min, max) => Math.floor(Math.random() * (max - min + 1)) + min, []);

  const enhance = useCallback((id) => {
    const element = document.getElementById(id);
    const text = element.innerText.split('');
    element.innerText = '';
    text.forEach((value, index) => {
      const outer = document.createElement('span');
      outer.className = 'outer';
      const inner = document.createElement('span');
      inner.className = 'inner';
      inner.style.animationDelay = `${rand(-5000, 0)}ms`;
      const letter = document.createElement('span');
      letter.className = 'letter';
      letter.innerText = value;
      letter.style.animationDelay = `${index * 1000}ms`;
      inner.appendChild(letter);
      outer.appendChild(inner);
      element.appendChild(outer);
    });
  }, [rand]);

  useEffect(() => {
    enhance('name');

    const timer = setTimeout(() => {
      const nameElement = document.getElementById('name');
      nameElement.classList.add('active-hover');

      setTimeout(() => {
        nameElement.classList.remove('active-hover');
      }, 3000);
    }, 3000);

    return () => clearTimeout(timer);
  }, [enhance]);

  return (
    <div id="landing-page">
      <header id="landing-header" className="font-SpaceGrotesk">
        <div className="top-left">
          <HoverEffect text="Dagim" />
        </div>
        <div className="top-right">
          <Resume />
        </div>
        <h1 className="greeting ease-in">
          HEY, I'M <span id="name" className="fancy">DAGIM JALLETA</span><br />
          BUT YOU CAN CALL ME DRACO
        </h1>
        <h2 className="subtitle ease-in">
          I'm a software engineer, full-stack developer<br />& database administrator.
        </h2>
        <div className="links ease-in">
          <a href="/projects" className="link">→ see my projects</a>
          <a href="/about" className="link">→ learn more</a>
        </div>
      </header>
    </div>
  );
};

export default Portfolio;